import * as Sentry from "@sentry/astro";
import {
  PUBLIC_SENTRY_DSN,
  PUBLIC_SENTRY_ERROR_SAMPLERATE,
  PUBLIC_SENTRY_PROJECT,
  PUBLIC_SENTRY_SESSION_SAMPLERATE,
  PUBLIC_SENTRY_TRACE_SAMPLERATE,
} from "astro:env/client";
import { createSentryClientConfig } from "villa-utils/src/functions/sentryConfig";

const config = createSentryClientConfig({
  dsn: PUBLIC_SENTRY_DSN,
  project: PUBLIC_SENTRY_PROJECT,
  environment: import.meta.env.VERCEL_ENV,
  tracesSampleRate: PUBLIC_SENTRY_TRACE_SAMPLERATE,
  replaysSessionSampleRate: PUBLIC_SENTRY_SESSION_SAMPLERATE,
  replaysOnErrorSampleRate: PUBLIC_SENTRY_ERROR_SAMPLERATE,
  debug: false,
});

if (config) Sentry.init(config);
